<template>
    <div class="block-bid-prebid">
        <div class="block-bid">
            <div v-if="!isEnterPriceBargain && !isApprovedBargain && !isBuyNow" class="block-time-end mb-4">
                <div class="block-top">
                    <div class="text">残り時間</div>
                    <div class="time-end">
                        <span class="number">{{ timeEnd }}</span>
                    </div>
                    <div class="d-flex justify-content-center mt-2">
                        <div class="">{{formattedDate}}</div>
                    </div>
                </div>
            </div>
            <div class="block-sm">
                <div class="block-current-price">
                    <div v-if="isBuyNow || isApprovedBargain" class="text-center mb-2 text-bought">販売終了</div>
                    <div class="current-price border-color-yellow">
                        <div class="top">
                            <div v-if="this.isError" class="d-flex justify-content-center pb-10">
                                <div class="font-weight-bold text-center not-available-product">
                                    販売終了
                                </div>
                            </div>
                            <div class="text-price-now font-weight-bold">
                                即決価格
                            </div>
                            <div class="price color-yellow">
                                <span class="number">¥</span>
                                <span class="number">{{
                                        formatPrice(product.price_buy_now)
                                    }}</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">¥ {{
                                        handlePriceTaxAndServiceFee(product.price_buy_now)
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-prie-bid pt-0">
                    <div class="block-bottom">
                        <div v-if="isEnterPriceBargain">
                            <div>
                                希望価格を入力してください
                            </div>
                            <input  v-model="priceBargain" @input="validateNumberInput()" type="text" id="input-price-bargain" class="input-bid input-enter-price-bargain">
                            <div id="errors-price-bargain" class="error d-none">{{ messErrPriceBargain }}</div>
                            <button :disabled="isApprovedBargain || isAdminViewer" :class="(isApprovedBargain || isAdminViewer) ? 'btn-bargain-disable' : ''" class="btn-bargain mt-3" @click.prevent="handleSendBargainPrice">希望価格を送信する</button>
                        </div>
                        <button v-else :disabled="isBuyNow || isApprovedBargain || this.isError || !this.checkAvailableTime || isAdminViewer"
                                :class="(isBuyNow || isApprovedBargain || isAdminViewer) ? 'btn-bargain-disable' : ''"
                                class="btn-large"
                                @click.prevent="redirectEnterPriceBargain"
                        >
                            値下げ交渉する
                        </button>

                        <button :disabled="isBuyNow || isApprovedBargain || this.isError || !this.checkAvailableTime || isAdminViewer"
                                :class="(isBuyNow || isApprovedBargain || isAdminViewer) ? 'btn-buy-now-disable' : ''"
                                class="btn-buy-now mt-10"
                                @click.prevent="openModalBuyNow"
                        >
                            今すぐ落札
                        </button>
                        <!-- Modal Buy Now -->
                        <div class="modal fade" id="priceBidBuyNowProductModal" tabindex="-1" aria-labelledby="exampleModalLabel"
                             aria-hidden="true" data-backdrop="static">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header border-bottom-0">
                                        <h3 class="modal-title font-weight-bold text-right" style="width: 64%">今すぐ落札確認</h3>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="text-center mt-4">
                                        <span>即決価格 :</span>
                                        <span class="color-yellow">¥{{ formatPrice(product.price_buy_now) }}</span>
                                    </div>
                                    <div class="text-center mt-1">
                                        <span>手数料含む</span>
                                        <span>(¥{{
                                                handlePriceTaxAndServiceFee(product.price_buy_now)
                                            }})</span>
                                    </div>
                                    <div class="text-center mt-1 mb-4">
                                        <span>この金額で入札する</span>
                                    </div>
                                    <div class="modal-footer border-top-0 justify-content-center">
                                        <button @click="storeBidBuyNow()" class="btn btn-submit-modal-bid-price-product">すぐ落札する</button>
                                        <button type="button" class="btn btn-cancel-modal-bid-price-product" data-dismiss="modal">いいえ</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Modal Price Bargain -->
                        <div class="modal fade" id="priceBargainProductModal" tabindex="-1" aria-labelledby="exampleModalLabel"
                             aria-hidden="true" data-backdrop="static">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header border-bottom-0">
                                        <h3 class="modal-title font-weight-bold text-right" style="width: 55%">確認</h3>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="text-center mt-4">
                                        <span>希望価格 :</span>
                                        <span class="color-red">¥{{ formatPrice(priceBargain) }}</span>
                                    </div>
                                    <div class="text-center mt-1">
                                        <span>手数料含む</span>
                                        <span>(¥{{ handlePriceTaxAndServiceFee(priceBargain) }})</span>
                                    </div>
                                    <div class="text-center mt-1 mb-4">
                                        <span>この金額で値下げ交渉する</span>
                                    </div>
                                    <div class="modal-footer border-top-0 justify-content-center">
                                        <button @click="storePriceBargain()" class="btn btn-submit-modal-bid-price-product">送信する</button>
                                        <button type="button" class="btn btn-cancel-modal-bid-price-product" data-dismiss="modal">キャンセル</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="block-history mt-4">
            <div class="text-history text-center">
                あなたの値下げ交渉履歴
                <span v-if="countHistoryBargain < 3 && histories && (!showBidSuccess || !checkShowSuccessBid)"> （0件）</span>
                <span v-else-if="countHistoryBargain < 3 && histories"> （{{ countHistoryBargain + 1 }}件）</span>
                <span v-else-if="countHistoryBargain"> （{{ countHistoryBargain }}件）</span>
                <span v-else> （0件）</span>
            </div>
            <div class="history">
                <div class="">
                    <div v-if="histories && countHistoryBargain < 3 && (showBidSuccess || checkShowSuccessBid)" class="item-history">
                        <div class="left-history ml-4">
                            <button class="tag tag-red-bargain">すぐ落札</button>
                        </div>
                        <div class="right-history">
                            <div class="top">
                                ¥{{ formatPrice(histories.amount) }}
                            </div>
                            <div class="bottom">{{ formatDate( histories.created_at ) }}</div>
                        </div>
                    </div>
                    <div class="item-history" v-for="history in historyBargains">
                        <div class="left-history ml-4">
                            <button class="tag tag-red-bargain">{{ history.bargain_number }}<span>回目</span></button>
                        </div>
                        <div class="right-history">
                            <div class="top">
                                ¥{{ formatPrice(history.amount) }}
                                <span>（{{ history.text_status }}）</span>
                            </div>
                            <div class="bottom">{{ formatDate( history.status == 2 ? history.created_at : history.updated_at ) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CONSTANTS from "../constants";
import moment from "moment-timezone";
import {COMMON, CONSTANT} from "../../common";

export default {
    mounted() {

    },
    async created() {
        await this.getDataBid();
        await this.getDataBidBuyNow();
        await this.getDataBargain();
        await this.getAuctionProduct();

        Echo.channel('auction.check_error_product' + this.auction.id + '.' + this.product.id)
            .listen('.auction.check_error_product',  (e) => {
                this.getAuctionProduct();
            });

        Echo.channel('auction.product.buyNow.' + this.auction.id + '.' + this.product.id)
            .listen('.auction.product.buyNow', (e) => {
                if (e.buyNow) {
                    this.isBuyNow = true;
                }
            });

        Echo.channel('auction.product.bargain.accepted.' + this.auction.id + '.' + this.product.id)
            .listen('.auction.product.bargain.accepted', (e) => {
                if (e.accept) {
                    this.isApprovedBargain = true;
                    this.getDataBidBuyNow();
                    this.getDataBargain();
                }
            });

        this.countDownTime();

        this.interval = setInterval(() => {
            this.countDownTime();
        }, 1000);
    },
    props: [
        'product',
        'auction',
        'product_auction',
        'is_enter_price_bargain',
        'is_admin_viewer'
    ],
    data: function () {
        return {
            serviceFee: 0,
            tax: 0,
            countHistoryBargain: 0,
            timeEnd: null,
            interval: null,
            member: null,
            histories: null,
            checkStateAuction: this.auction.state,
            checkProductAuction: this.product_auction,
            historyBargains: null,
            isBuyNow: false,
            isApprovedBargain: false,
            isEnterPriceBargain: this.is_enter_price_bargain,
            priceBargain: 0,
            pricePreviousBargain: 0,
            messErrPriceBargain: '',
            isError: false,
            formattedDate: null,
            currentTime: moment().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss'),
            showBidSuccess: false,
            isAdminViewer: !!this.is_admin_viewer,
        }
    },
    methods: {
        async getDataBid() {
            await axios.post('/bid/get-data-bid-pre-bid', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.member = res.data.member;
                    this.serviceFee = res.data.taxConfig.service_fee
                    this.tax = res.data.taxConfig.tax
                })
                .catch(error => {

                })
        },

        async getAuctionProduct() {
            await axios.post('/bid/get-data-auction-product', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.checkProductAuction = res.data.auctionProduct;
                    this.isError = !!res.data.auctionProduct.is_error;
                    this.formattedDate = this.formatDateJapanese(res.data.auctionProduct.end_time_online);
                })
                .catch(error => {

                })
        },

        async getDataBidBuyNow() {
            await axios.post('/bid/get-data-buy-now-bid', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    if (res.status === 200 && res.data) {
                        this.histories = res.data;
                        this.isBuyNow = true;
                    }
                })
                .catch(error => {

                })
        },

        async storeBidBuyNow() {
            if(this.checkAvailableTime) {
                await axios.post('/bid/store-buy-now-bid', {
                    auctionId: this.auction.id,
                    productId: this.product.id,
                    amount: this.product.price_buy_now,
                })
                    .then(response => {
                        if (response.status === 200) {
                            this.isBuyNow = true;
                            this.getDataBidBuyNow();
                            window.location.href = `/auction/${this.auction.id}/product/${this.product.id}/notification/buy-now/${this.product.price_buy_now}`
                        }
                    })
                    .catch(error => {
                        if(error.response.status === 422) {
                            alert('オークション期間は終了しました。');
                            window.location.reload();
                        }
                    })
            } else {
                alert('オークション期間は終了しました。');
                window.location.reload();
            }
            this.closeModalBuyNow();
        },

        async getDataBargain() {
            await axios.post('/bargain/get-data-bargain', {
                auctionId: this.auction.id,
                productId: this.product.id,
                memberId: this.member.id,
            })
                .then(res => {
                    if (res.data.approvedBargain) {
                        this.isApprovedBargain = true;
                    }
                    if (res.data.memberBargain.length > 0) {
                        this.historyBargains = res.data.memberBargain;
                        this.countHistoryBargain = res.data.memberBargain ? res.data.memberBargain.length : 0;
                        this.historyBargains.forEach(item => {
                            if (item.status == 1) {
                                item["text_status"] = '成約';
                            }
                            if (item.status == 2) {
                                item["text_status"] = '交渉中';
                            }
                            if (item.status == 3 || item.status == 4 || item.status == 5) {
                                item["text_status"] = '交渉不成立';
                            }
                        });
                        if (this.countHistoryBargain > 0) {
                            this.priceBargain = this.pricePreviousBargain = this.formatPrice(JSON.parse(JSON.stringify(this.historyBargains))[0].amount);
                        }
                        if (this.countHistoryBargain == 3) {
                            this.isApprovedBargain = true;
                        }
                    }
                    if (this.countHistoryBargain == 3) {
                        this.isApprovedBargain = true;
                    }
                    if (this.checkProductAuction.state === CONSTANTS.AUCTION_STATE_FINISH && this.member.id == this.checkProductAuction.member_id) {
                        this.showBidSuccess = true;
                    } else {
                        this.showBidSuccess = false;
                    }
                })
                .catch(error => {

                })
        },

        async storePriceBargain() {
            if(this.checkAvailableTime) {
                await axios.post('/bargain/store-bargain', {
                    auctionId: this.auction.id,
                    productId: this.product.id,
                    amount: this.priceBargain,
                })
                    .then(res => {
                        if (res.status === 200 && res.data.bargain) {
                            this.getDataBargain();
                            window.location.href = `/auction/${this.auction.id}/product/${this.product.id}/notification/bargain/${this.priceBargain}`
                        }
                    })
                    .catch(error => {
                        if(error.response.status === 422) {
                            alert('オークション期間は終了しました。');
                            window.location.reload();
                        }
                    })
            } else {
                alert('オークション期間は終了しました。');
                window.location.reload();
            }
            this.closeModalPriceBargain();
        },

        formatPrice(price) {
            return COMMON.handleFormatPrice(price);
        },

        countDownTime() {
            this.timeEnd = COMMON.handleCountDownTime(this.checkProductAuction.end_bid_pre_bid_time, this.auction.end_time, this.auction.start_time, this.interval);
            if(this.timeEnd === "0 : 0 : 0 ") {
                this.currentTime = moment().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss')
            }
            return this.timeEnd;
        },

        formatDate(time) {
            return COMMON.handleFormatDate(time);
        },

        handlePriceTaxAndServiceFee(pricePresent) {
            let price = COMMON.handlePriceTaxAndServiceFee(pricePresent, this.serviceFee, this.tax);

            return this.formatPrice(price);
        },

        redirectEnterPriceBargain() {
            if (!this.isError && this.checkAvailableTime) {
                window.location.href = `/auction/${this.auction.id}/product/${this.product.id}/submitBargain`
            }
        },

        parseIntPrice() {
            if (this.priceBargain && typeof this.priceBargain === 'string') {
                this.priceBargain = parseInt(this.priceBargain.replace(/[^0-9]/g, ''))
            }
            if (this.pricePreviousBargain && typeof this.pricePreviousBargain === 'string') {
                this.pricePreviousBargain = parseInt(this.pricePreviousBargain.replace(/[^0-9]/g, ''))
            }
        },

        handleSendBargainPrice() {
            this.parseIntPrice();
            this.checkAvailableTime;
            if (this.priceBargain) {
                if (this.priceBargain < this.pricePreviousBargain) {
                    this.messErrPriceBargain = '前回交渉した価格より大きい価格を入力してください。';
                    this.handleDisplayErrPriceBargain();
                } else {
                    this.openModalPriceBargain();
                }
            } else {
                this.messErrPriceBargain = '希望価格を入力してください。';
                this.handleDisplayErrPriceBargain();
            }
        },

        validateNumberInput() {
            this.priceBargain = COMMON.maximumCharacterLimitPrice(event.target.value.replace(/[^0-9]/g, ''));
        },

        handleDisplayErrPriceBargain() {
            document.getElementById('errors-price-bargain').classList.remove('d-none');
            setTimeout(function () {
                document.getElementById('errors-price-bargain').classList.add('d-none');
            }, 5000);
        },

        openModalBuyNow() {
            if (!this.isError && this.checkAvailableTime) {
                $('#priceBidBuyNowProductModal').modal('show');
            }
        },

        closeModalBuyNow() {
            $('#priceBidBuyNowProductModal').modal('hide');
        },

        openModalPriceBargain() {
            $('#priceBargainProductModal').modal('show');
        },

        closeModalPriceBargain() {
            $('#priceBargainProductModal').modal('hide');
        },

        formatDateJapanese(dateString) {
            const date = new Date(dateString)

            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')

            const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土']
            const dayOfWeek = daysOfWeek[date.getDay()]

            return `${month}/${day}(${dayOfWeek}) ${hours}:${minutes} 終了予定`
        },
    },
    computed: {
        checkAvailableTime: function () {
            let auctionEndBid = moment(this.auction.end_time).format('YYYY-MM-DD HH:mm:ss');
            let auctionLiveTime = moment(this.auction.start_time).format('YYYY-MM-DD HH:mm:ss');

            return !!(auctionEndBid &&  auctionLiveTime && ((this.currentTime > auctionLiveTime) && (this.currentTime < auctionEndBid)));
        },

        checkShowSuccessBid: function () {
            if (this.checkProductAuction.state === CONSTANTS.AUCTION_STATE_FINISH && this.member.id == this.checkProductAuction.member_id) {
                return true;
            }
            return false;
        },
    }
}
</script>
